import React, {  } from "react"
import { Text, View, Image, TouchableOpacity, StyleSheet, TextInput, ScrollView } from "react-native";
import { store } from "../../../store/store";
import * as ImagePickerFunc from 'expo-image-picker';
import { MaterialIcons } from '@expo/vector-icons';
import AppTheme from "../../../AppTheme";
import { updateReduxCurrentAnswer, updateReduxImageList } from "../../services/redux/commonRedux";
import AppStyles from "../../../AppStyles";
import { getConsultationAnsValue } from "../../services/econsult/EConsultUtils";

export default class ImagePicker extends React.Component<any, any>   {

    constructor(props) {
        super(props);
        this.state = {
            qData : {},
            ansData : {},
            imageData : {},
            selectedImageList : [],
            render: false
        }
    }
    // const [data, updateData] = useState({
    //     qData: {},
    //     render: false
    // });

    // const [selectedImageList, updateImageList] = useState([{}]);


    componentDidMount() {
        const reduxState = store.getState();
        if (reduxState.currentConsultationQuestion) {
            this.setState({ qData: reduxState.currentConsultationQuestion,
                ansData : reduxState.currentConsultationAnswer,
                imageData: reduxState.consultImageData,
                render: true })
        }
    }

    openImagePickerAsync = async () => {
        var qData = this.state.qData, ansData = this.state.ansData,
        imageData = this.state.imageData, imageList = this.state.imageData[qData['qid']];
        let permissionResult = await ImagePickerFunc.requestMediaLibraryPermissionsAsync();
        if (permissionResult.granted === false) {
            alert("Permission to access camera roll is required!");
            return;
        } 
        let pickerResult = await ImagePickerFunc.launchImageLibraryAsync({
            mediaTypes: ImagePickerFunc.MediaTypeOptions.Images
        });
        let imgObj : any = pickerResult['uri'];
        
        var uuid = require('react-native-uuid');
        const uuId = uuid.v4();
        const id = qData['qid'];
        const rskey = qData['rskey'];
        const ansVal = [{
            note : '',
            handle : uuId
        }];
        if (ansData && ansData[id] && ansData[id][rskey]) 
        ansData[id][rskey] = ansData[id][rskey].concat(ansVal);
        else ansData = {
            [id] : {
                id : id,
                [rskey] : ansVal,
                textInput : ''
            }
        };
        if (imageList && imageList.length > 0)
            imageList.push({ [uuId] : imgObj });
        else imageList = [{ [uuId] : imgObj }];
        imageData[id] = imageList;
        this.setState({ imageData: imageData, ansData: ansData });
        updateReduxImageList(imageData);
        updateReduxCurrentAnswer(ansData);
    }

    onChangeText = (text, index, qData, ansData) => {
        ansData[qData['qid']][qData['rskey']][index]['note'] = text
        this.setState({ ansData: ansData });
        updateReduxCurrentAnswer(ansData);
    }

    removeImageItem = (index) => {
        var qData = this.state.qData, ansData = this.state.ansData, imageData = this.state.imageData, imageList = this.state.imageData[qData['qid']];
        const id = qData['qid'], rskey = qData['rskey'];
        ansData[id][rskey].splice(index, 1);
        imageList.splice(index, 1);
        imageData[id] = imageList;
        this.setState({ imageData: imageData, ansData: ansData });
        updateReduxImageList(imageData);
        updateReduxCurrentAnswer(ansData);
    }

    getImageURL(item, index) {
        const qData = this.state.qData, ansData = this.state.ansData
        var url= '';
        if (getConsultationAnsValue(qData, ansData) && getConsultationAnsValue(qData, ansData)[index] && getConsultationAnsValue(qData, ansData)[index]['handle'])
            url = item[getConsultationAnsValue(qData, ansData)[index]['handle']];
        return url;
    }

    render() {
        return <ScrollView style={{marginHorizontal: 16}}>
            <Text style={AppStyles.questionText}>
                {this.state.qData['qstr']}
            </Text>
            <View style={styles.container}>
                {
                    Object.keys(this.state.imageData).length > 0 &&  this.state.imageData[this.state.qData['qid']] &&
                        this.state.imageData[this.state.qData['qid']].length > 0 && Object.keys(this.state.ansData).length > 0 ?
                    this.state.imageData[this.state.qData['qid']].map((image, i) =>
                        <View key={i} style={styles.imageContainer}>
                            <View style={styles.imgView}>
                                <Image source={{ uri: this.getImageURL(image, i)}}
                                    style={styles.thumbnail} />
                                <MaterialIcons onPress={() => this.removeImageItem(i)} style={styles.cancelIcon} name='clear' />
                            </View>
                     
                            <TextInput style={styles.imageInput}
                                multiline
                                value={getConsultationAnsValue(this.state.qData, this.state.ansData) && getConsultationAnsValue(this.state.qData, this.state.ansData)[i]
                                    ? getConsultationAnsValue(this.state.qData, this.state.ansData)[i]['note'] : ''}
                                onChangeText={text => this.onChangeText(text, i, this.state.qData, this.state.ansData)}
                                editable
                            />
                        </View>
                    ) : <View/>
                }
                <TouchableOpacity onPress={() => this.openImagePickerAsync()} 
                style={styles.AddPicButton}>
                    <MaterialIcons style={{ paddingRight: 70, paddingLeft: 30 }}
                    size={20} name='camera-alt'/>
                    <Text style={styles.buttonText}>ADD A PICTURE</Text>
                </TouchableOpacity>
            </View>
            <View style={{height: 100}}/>

        </ScrollView>
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        alignItems: 'center',
        justifyContent: 'center',
        margin: 16
    },
    thumbnail: {
        width: 75,
        height: 65,
        padding: 10, 
        marginBottom: 20,
    },
    cancelIcon: {
        position: "absolute",
        right: -5,
        fontSize: 16,
        top: -5,
        fontWeight: '800'
    },
    AddPicButton: {
        fontSize: 14,
        color: AppTheme.color.primary,
        borderRadius: 4,
        borderColor: AppTheme.color.primary,
        borderWidth: 2,
        width: '100%',
        height: 41,
        flexDirection: 'row',
        justifyContent: "flex-start",
        alignItems: "center",
        margin: 16
    },

    buttonText: {
        fontSize: 14,
        color: AppTheme.color.primary,
        fontWeight: '600',
        padding: 10,
        fontFamily: 'Roboto_400Regular'
    },
    imageInput: {
        borderColor: 'f5f5f5',
        borderWidth: 1,
        borderRadius: 4,
        padding: 4,
        with: '90%'
    },

    imageContainer: {
        flex: 1,
        width: '100%',
        flexDirection: 'row',
        justifyContent: "flex-start",
        marginVertical: 10
    },

    imgView: {
         width: '30%',
        // height: 60,
        position: "relative",
        margin: 12
    }
});
